import { generateExample } from '#environment/index.js';
import { removeUndefined } from '../../utils/objects.js';
import BaseField from './BaseField.js';
class StringField extends BaseField {
    default;
    format;
    pattern;
    minLength;
    maxLength;
    constructor(data = {}) {
        super({
            ...data,
            example: data.example ?? data.default,
        });
        this.default = data.default;
        this.format = data.format;
        this.pattern = data.pattern;
        this.minLength = data.minLength;
        this.maxLength = data.maxLength;
        this.proto.type = 'string';
    }
    getExample(_transport) {
        if (this.example === undefined) {
            this.example = generateExample({
                format: this.format,
                pattern: this.pattern,
                minLength: this.minLength,
                maxLength: this.maxLength,
            });
        }
        return this.example;
    }
    toSchema(transport, options) {
        return removeUndefined({
            ...super.toSchema(transport, options),
            type: 'string',
            default: this.default,
            format: this.format,
            pattern: this.pattern,
            minLength: this.minLength,
            maxLength: this.maxLength,
        });
    }
    fromJSON(input) {
        return input;
    }
}
export default StringField;
//# sourceMappingURL=StringField.js.map